import { useEffect, useId, useRef, useState } from "react";

let mermaidPromise: Promise<typeof import("mermaid")["default"]> | null = null;

function loadMermaid() {
  if (!mermaidPromise) {
    mermaidPromise = import("mermaid").then((mod) => {
      mod.default.initialize({
        startOnLoad: false,
        theme: "dark",
        securityLevel: "strict",
        fontFamily: "Manrope, sans-serif",
        themeVariables: {
          background: "#0a0f0b",
          primaryColor: "#101a12",
          primaryTextColor: "#eef3ea",
          primaryBorderColor: "#2fe6a8",
          lineColor: "#4d5f4f",
          secondaryColor: "#161f18",
          tertiaryColor: "#101a12",
          fontSize: "14px",
        },
        flowchart: { curve: "basis", padding: 14 },
      });
      return mod.default;
    });
  }
  return mermaidPromise;
}

export function Mermaid({ chart, caption }: { chart: string; caption?: string }) {
  const id = useId().replace(/:/g, "m");
  const containerRef = useRef<HTMLDivElement>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    loadMermaid()
      .then((mermaid) => mermaid.render(`mmd-${id}`, chart))
      .then(({ svg }) => {
        if (!cancelled && containerRef.current) containerRef.current.innerHTML = svg;
      })
      .catch((err) => {
        if (!cancelled) setError(String(err?.message ?? err));
      });
    return () => {
      cancelled = true;
    };
  }, [chart, id]);

  return (
    <figure className="pf-mermaid">
      {error ? <p className="pf-mermaid-error">Diagram failed to render.</p> : <div ref={containerRef} className="pf-mermaid-canvas" />}
      {caption && <figcaption>{caption}</figcaption>}
    </figure>
  );
}
